import Header, { HeaderLeft } from "../../../layout/Header/Header";
import CommonHeaderRight from "./CommonHeaderRight";

const AccountLedgerHeader = () => {
  return (
    <Header>
      <HeaderLeft>
        <div>
          <div className="fw-bold fs-6 mb-0">Account Ledger</div>
          <div className="text-muted">
            <small>
              Complete transaction journal for the flat.
            </small>
          </div>
        </div>
      </HeaderLeft>
      <CommonHeaderRight />
    </Header>
  );
};

export default AccountLedgerHeader;
